export function extend(obj) {
  var length = arguments.length
  if (length < 2 || obj == null) return obj
  for (var index = 1; index < length; index++) {
    var source = arguments[index],
      keys = Object.keys(source),
      l = keys.length
    for (var i = 0; i < l; i++) {
      var key = keys[i]
      if (obj[key] === void 0) obj[key] = source[key]
    }
  }
  return obj
}

/**
 * 获取cgi环境
 * @param sandbox
 * @returns {string}
 */
export function getCgiEnv(sandbox) {
  let env = ""
  if (sandbox == 1) {
    env = "sandbox."
  } else if (sandbox == 2) {
    env = "dev."
  }
  return env
}

/**
 * 解构赋值，将 loginState 变成 cgi 可接受执行
 * @param loginState
 * @returns {{openid: *, openkey: *, session_id: *, session_type: *}}
 * 避免页面有 openid/openkey 重复传递的情况
 */
export function getLoginState(loginState) {
  let { openid, openkey, sessionId: session_id, sessionType: session_type, wxAppid2: wx_appid } = loginState

  return {
    openid,
    openkey,
    session_id,
    session_type,
    wx_appid,
    WxAppid: wx_appid
  }
}

/**
 * 检测一个对象是否为空
 * 为空返回 true
 * 非空返回 false
 * @param obj
 * @returns {boolean}
 */
export function isObjectEmpty(obj) {
  for (let key in obj) {
    return false
  }
  return true
}

/**
 * 注意这里使用自定义 base64
 * 主要是由于 window.btoa 只能编码 ASCII 码
 * 需要 encode 后再 btoa, 但是某些cgi 不需要 encode
 * 故此重新声明 base64
 * @param input
 * @returns {string}
 */
export function base64encode(input) {
  let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  let output = ""
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4
  let i = 0

  let utf8Encode = function(string) {
    string = string.replace(/\r\n/g, "\n")
    let utftext = ""
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }
  input = utf8Encode(input)
  while (i < input.length) {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
  }
  return output
}

export function clone(obj) {
  var str,
    newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== "object") {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj)
    //系列化对象
    newobj = JSON.parse(str)
    //还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === "object" ? clone(obj[i]) : obj[i]
    }
  }
  return newobj
}

/**
 * 限制频率 throttle 函数
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export function throttle(func, wait, options) {
  let timeout, context, args, result
  let previous = 0
  if (!options) options = {}

  const later = function() {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }

  const throttled = function() {
    let now = Date.now()

    if (!previous && options.leading === false) previous = now

    let remaining = wait - (now - previous)

    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }

  throttled.cancel = function() {
    clearTimeout(timeout)
    previous = 0
    timeout = context = args = null
  }

  return throttled
}
